<div class="driver-modal">
  <div class="sec_head">
    <h2>{{'Add Driver document' | translate}} </h2>
  </div>
  <div class="modal-body">
    <form class="attribute-modal">
      <div class="form_feilds gap_m">
        <div class="usr_profile">
          <p>{{ 'UploadImage' | translate }}</p>
          <div class="position_relative usr_profile_img_wrp">
            <figure class="usr_profile_img">
              <img src="{{assetsConst.UserProfile}}" alt="user" />
            </figure>
            <figure class="camera_icon hide_camera">
              <img src="{{assetsConst.cameraIcon}}" alt="" />
              <input type="file" class="form_control" />
            </figure>
          </div>
        </div>
        <div class="form_group">
          <mat-label class="required"> {{ ' Name ' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input matInput placeholder=" {{ ' Name ' | translate }}" class="form_control" />
          </mat-form-field>
        </div>
        <div class="form_group">
          <mat-label class="required"> {{ ' Title ' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input matInput placeholder=" {{ ' Title ' | translate }}" class="form_control" />
          </mat-form-field>
        </div>
        <div class="form_group">
          <mat-label class="required"> {{ ' Description ' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <textarea matInput placeholder=" {{ ' Description ' | translate }}" class="form_control"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="submit_btn">
        <button class="btnn btn_primary" type="submit">{{ 'Submit' | translate }}</button>
      </div>
    </form>
  </div>
</div>
